import { useState, useEffect } from "react";
import axios from "axios";
import { addRowCount } from "./agentTabs";
import DataTable from 'react-data-table-component';
import { Link } from "react-router-dom";
import AgentFileUpload from "./AgentFileUpload";


const DocumentUpload = ({agentId,label,api,columns}) => {
    
    
    const [data, setData] = useState([]);
    const [page,setPage] = useState(1);
    const [perPage,setPerPage] = useState(10);
    const [totalRows,setTotalRows] = useState(0);
    const [showUploadSection, setShowUploadSection] = useState(false);
    const [refreshData, setRefreshData] = useState(false);

    const handleToggleSection = () => {
        setShowUploadSection(prev => !prev)
    }

    useEffect(() => {
        console.log('id: ',agentId)
        const fetchData = async () => {
            try {
                const res = await axios.get(`${process.env.REACT_APP_API_URL}${api}`,{
                    params: {
                        'agentId' : agentId,
                        'page': page,
                        'limit': perPage
                    }
                })
                const result = addRowCount(res?.data?.data,page,perPage)
              
                setData(result);
                setTotalRows(res?.data?.totalCount);
                setPage(1);               
            } catch (error) {
                console.log(`Error fetching ${label} data: `,error)
            }
        }
        setData([]);
        fetchData();
    },[page,perPage,refreshData]);

    return (
        <>

            
            
            {
                showUploadSection ? 
                    <AgentFileUpload agentId={agentId} handleToggleSection={handleToggleSection} setRefreshData={setRefreshData}/> :
                    (
                        <>
                            <button 
                                onClick={handleToggleSection} 
                                className="px-4 py-2">Upload Document</button>
                            <div className="row grid">
                                <DataTable
                                    columns={columns}
                                    data={data}
                                    responsive
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    onChangePage={(newPage) => setPage(newPage)}
                                    onChangeRowsPerPage={(newPerPage, currentPage) => setPerPage(newPerPage)}
                                />
                            </div>
                        </>
                    ) 

            }
        </>
    )
}



export default DocumentUpload;